'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncComponent = exports.createAsyncContext = exports.AsyncComponentProvider = undefined;

var _AsyncComponentProvider = require('./AsyncComponentProvider');

var _AsyncComponentProvider2 = _interopRequireDefault(_AsyncComponentProvider);

var _createAsyncContext = require('./createAsyncContext');

var _createAsyncContext2 = _interopRequireDefault(_createAsyncContext);

var _asyncComponent = require('./asyncComponent');

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AsyncComponentProvider = _AsyncComponentProvider2.default;
exports.createAsyncContext = _createAsyncContext2.default;
exports.asyncComponent = _asyncComponent2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-async-component/commonjs/index.js
// module id = 93
// module chunks = 1